import { formatFloat } from '../../shared/utils/helpers';
import { isValidValue } from '../../shared/utils/validations';
import { fetchGroupsBasicInfo, fetchGroupsRanksComps } from '../../services/killshot';
import { selectedGroupRanksComps } from './pricing';

export const setGroupsAction = groups => ({
  type: 'SET_GROUPS',
  payload: groups,
});

export const setGroupsBasicInfoAction = groups => ({
  type: 'SET_GROUPS_BASIC_INFO',
  payload: groups,
});

export const setGroupsRanksCompsAction = groups => ({
  type: 'SET_GROUPS_COMPS',
  payload: groups,
});

export const setInitialGroupsAction = groups => ({
  type: 'SET_INITIAL_GROUPS',
  payload: groups,
});

export const setInitMarketplacesAction = initialMarketplaces => ({
  type: 'SET_INITIAL_MARKEPTLACES',
  payload: initialMarketplaces,
});

export const setGroupFieldsAction = (groupFields, groupId) => ({
  type: 'SET_GROUP_FIELDS',
  fields: groupFields,
  group: groupId,
});

export const setPushEnableAction = status => ({
  type: 'SET_PUSH_ENABLE',
  payload: status,
});

export const setLoadingGroupsAction = status => ({
  type: 'SET_LOADING_GROUPS',
  payload: status,
});

export const updateGroupFields = newGroupFields => dispatch => {
  dispatch(setGroupFieldsAction(newGroupFields));
};

export const setLoadingGroupsCompsAction = status => ({
  type: 'SET_LOADING_GROUPS_COMPS',
  payload: status,
});

export const groupsIds = groupsList => {
  return groupsList.map(group => group.id);
};

export const setMPAction = (marketplaces, groupId) => ({
  type: 'SET_MARKETPLACES',
  marketplaces,
  group: groupId,
});

export const removeMarketplace = groupId => ({
  type: 'REMOVE_MARKETPLACE',
  groupId,
});

export const updateGroupsMarketplaceComps = (marketplace, groupId, comps) => ({
  type: 'UPDATE_GROUPS_MARKETPLACE_COMPS',
  marketplace,
  groupId,
  comps,
});

export const updateBroadcastingStrategy = newStrategy => ({
  type: 'UPDATE_BROADCASTING_STRATEGY',
  payload: newStrategy,
});

const groupsSelector = groups =>
  groups.map(item => ({
    ...item,
    floor: formatFloat(item.floor),
    ceiling: isValidValue(item.ceiling) ? formatFloat(item.ceiling) : '',
    split_type: item.split_type || item.ranks[0]?.split_type || '',
    custom_split: item.custom_split || item.ranks[0]?.custom_split || 1,
  }));

export const refreshGroups = (skyboxId, refresUIinfo = false, groupId = null) => dispatch => {
  dispatch(setLoadingGroupsCompsAction(true));
  fetchGroupsBasicInfo(skyboxId, true)
    .then(response => {
      const serverGroups = response?.response?.reverse();
      dispatch(setGroupsAction(serverGroups));
      dispatch(setInitialGroupsAction(groupsSelector(serverGroups)));
      if (refresUIinfo || groupId) {
        dispatch(setGroupFieldsAction({}, groupId));
        dispatch(setPushEnableAction(false));
      }
      dispatch(setLoadingGroupsAction(false));
      const groupsIdsArray = groupsIds(serverGroups);
      if (groupsIdsArray.length > 0) {
        fetchGroupsRanksComps(skyboxId, JSON.stringify(groupsIdsArray), true)
          .then(compsResponse => {
            const serverGroupsComps = compsResponse?.response?.reverse();
            dispatch(setGroupsRanksCompsAction(serverGroupsComps));
            if (refresUIinfo || groupId) {
              dispatch(setGroupFieldsAction({}, groupId));
              dispatch(setPushEnableAction(false));
            }
            dispatch(setLoadingGroupsCompsAction(false));
            // selectedGroupRanksComps is part of the pricing part of the state
            dispatch(selectedGroupRanksComps(serverGroupsComps));
          })
          .catch(error => {
            dispatch(setLoadingGroupsAction(false));
            dispatch(setLoadingGroupsCompsAction(false));
            throw error;
          });
      }
    })
    .catch(error => {
      dispatch(setLoadingGroupsAction(false));
      dispatch(setLoadingGroupsCompsAction(false));
      throw error;
    });
};
